import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	createKudosBadges,
	updateKudosBadges,
	deleteKudosBadges,
	addGroupsToKudosBadges,
	removeGroupsFromKudosBadges,
	setEventKudo,
} from '@/redux/actions';

const WS_KUDO_BY_HTTP = {
	CREATE_KUDO: `kudos/POST`,
	UPDATE_KUDO: `kudos/:kudosID/PATCH`,
	DELETE_KUDO: `kudos/:kudosID/DELETE`,
	CREATE_EVENT_KUDOS: `event/:eventID/kudos/POST`,
	UPDATE_EVENT_KUDOS: `event/:eventID/kudos/PATCH`,
	ADD_GROUPS: `kudos/:kudosID/addGroups/PATCH`,
	REMOVE_GROUPS: `kudos/:kudosID/removeGroups/PATCH`,
};

const KudosBadgesSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		kudosOrBadges,
		createKudosBadges,
		updateKudosBadges,
		deleteKudosBadges,
		addGroups,
		removeGroups,
		setEventKudo,
	} = props;

	const item = kudosOrBadges === 'kudos' ? 'Kudo' : 'Badge';
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToKudos = () => {
		socket.emit('event/kudos/:eventID/SUBSCRIBE', { eventID: currentEventId, kudosOrBadges });
		console.log('⚡️ KudosSubscriptions Mounted ⚡️', kudosOrBadges);
	};

	const unsubscribeToKudos = () => {
		socket.emit('event/kudos/:eventID/UNSUBSCRIBE', { eventID: currentEventId, kudosOrBadges });
		console.log(`🚶‍♂️ KudosSubscriptions Unmounted 🚶‍♂️`, kudosOrBadges);
	};

	const listenForCreatedKudo = () => {
		console.log(WS_KUDO_BY_HTTP.CREATE_KUDO, 'running');
		socket.on(WS_KUDO_BY_HTTP.CREATE_KUDO, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`${item} could not be created`, error);
			else {
				const { name } = data;
				createKudosBadges(data);
				displayMessage(`${name} created`);
			}
		});
	};

	const listenForUpdatedKudo = () => {
		socket.on(WS_KUDO_BY_HTTP.UPDATE_KUDO, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`${item} could not be updated`, error);
			else {
				const { name } = data;
				updateKudosBadges(data);
				displayMessage(`${name} ${item} updated`);
			}
		});
	};

	const listenForDeletedKudo = () => {
		socket.on(WS_KUDO_BY_HTTP.DELETE_KUDO, payload => {
			const { data, error } = payload;
			if (error) displayMessage(`${item} could not be deleted`, error);
			else {
				const { kudosName, deleteKudo } = data;
				deleteKudosBadges(deleteKudo.id);
				displayMessage(`${kudosName} succesfully deleted`);
			}
		});
	};

	const listenForCreatedEventKudos = () => {
		socket.on(WS_KUDO_BY_HTTP.CREATE_EVENT_KUDOS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Event kudos could not be created', error);
			else {
				setEventKudo({ id: data.event_id, event_kudo: data });
				displayMessage('Event kudos created');
			}
		});
	};

	const listenForUpdateEventKudos = () => {
		socket.on(WS_KUDO_BY_HTTP.UPDATE_EVENT_KUDOS, payload => {
			const { data, error } = payload;
			if (error)
				displayMessage(
					`${kudosOrBadges === 'kudos' ? 'Event kudos' : 'Leaderboard'} could not be updated`,
					error
				);
			else {
				setEventKudo({ id: data.event_id, event_kudo: data });
				displayMessage(`${kudosOrBadges === 'kudos' ? 'Event kudos' : 'Leaderboard'} updated`);
			}
		});
	};

	const listenForAddedGroups = () => {
		socket.on(WS_KUDO_BY_HTTP.ADD_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be added', error);
			else {
				const { addManyGroupsToKudo, kudoID } = data;
				addGroups(addManyGroupsToKudo, kudoID);
				displayMessage('Groups added to kudo');
			}
		});
	};

	const listenForRemovedGroups = () => {
		socket.on(WS_KUDO_BY_HTTP.REMOVE_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be removed', error);
			else {
				const { removeManyGroupsFromKudo, kudoID } = data;
				removeGroups(removeManyGroupsFromKudo, kudoID);
				displayMessage('Groups removed from kudo');
			}
		});
	};

	const listeners = () =>
		kudosOrBadges !== 'kudosLeaderboard'
			? [
					listenForCreatedKudo,
					listenForUpdatedKudo,
					listenForDeletedKudo,
					listenForCreatedEventKudos,
					listenForUpdateEventKudos,
					listenForAddedGroups,
					listenForRemovedGroups,
			  ]
			: [listenForCreatedEventKudos, listenForUpdateEventKudos];
	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToKudos}
				unsub={unsubscribeToKudos}
				listeners={listeners()}
				routes={Object.values(WS_KUDO_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createKudosBadges: (kudoBadge, from) => dispatch(createKudosBadges(kudoBadge, from)),
	updateKudosBadges: (kudoBadge, from) => dispatch(updateKudosBadges(kudoBadge, from)),
	deleteKudosBadges: (kudoBadgeID, from) => dispatch(deleteKudosBadges(kudoBadgeID, from)),
	addGroups: (groupIDs, kudoBadgeID, from) =>
		dispatch(addGroupsToKudosBadges(groupIDs, kudoBadgeID, from)),
	removeGroups: (groupIDs, kudoBadgeID, from) =>
		dispatch(removeGroupsFromKudosBadges(groupIDs, kudoBadgeID, from)),
	setEventKudo: (eventKudo, from) => dispatch(setEventKudo(eventKudo, from)),
});

export default connect(msp, mdp)(KudosBadgesSubscriptions);
